/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { getTheme, FontWeights, ICommandBarStyles } from "@fluentui/react";

const theme = getTheme();

/**
 * Styling for file upload container
 */
export const fileUploadContainer: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  margin: "5px",
};

/**
 * Styling for file input
 */
export const fileInputs: React.CSSProperties = {
  height: "30px",
  width: "250px",
  border: "1px solid #ccc",
};

/**
 * Styling for icon button
 */
export const iconButton: ICommandBarStyles = {
  root: {
    height: "30px",
    borderRadius: "0",
    color: "white",
    backgroundColor: "DodgerBlue",
    border: "none",
    margin: "4px 4px",
    cursor: "pointer",
  },
};

/**
 * Styling for text
 */
export const summaryText: React.CSSProperties = {
  color: "green",
  lineHeight: "0",
};

/**
 * Styling for text
 */
export const errorText: React.CSSProperties = {
  color: "red",
};

/**
 * Styling for the command bar extra margin
 */
export const updateCommandBarStyles = (): ICommandBarStyles => {
  return {
    root: {
      margin: "0 23px",
    },
  };
};

/**
 * Styling for the command bar
 */
export const commandBarStyles: ICommandBarStyles = {
  root: {
    borderRadius: "8px",
    boxShadow: " 0px 1px 4px rgba(0, 0, 0, 0.2)",
    margin: "0 0 1rem",
    padding: "0.75rem",
    selectors: {
      ["button"]: {
        marginRight: "36px",
      },
      [".ms-Button-label"]: {
        fontSize: "14px",
        fontWeight: FontWeights.semibold,
      },
      ["i[data-icon-name='Blocked']"]: {
        color: theme.palette.red,
      },
    },
  },
};
